import { motion } from 'framer-motion';
import { Clock, BarChart3, Activity, Users } from 'lucide-react';

interface RecentActivityProps {
    recentEntries: number;
    activeWellsCount: number;
    isDarkMode: boolean;
}

export function RecentActivity({ recentEntries, activeWellsCount, isDarkMode }: RecentActivityProps) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.4 }}
            className={`
        rounded-xl shadow-sm p-[1px]
        ${isDarkMode ? 'bg-gradient-to-br from-blue-500 to-indigo-600' : 'bg-transparent border border-gray-200'}
      `}
        >
            <div className={`p-4 rounded-xl h-full ${isDarkMode ? 'bg-slate-900' : 'bg-white'}`}>
                <h3 className={`text-lg font-semibold mb-4 flex items-center ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                    <Clock className="h-5 w-5 mr-2 text-blue-600" />
                    Recent Activity
                </h3>
                <div className="space-y-3">
                    {recentEntries > 0 && (
                        <div className={`flex items-center space-x-3 p-3 rounded-lg ${isDarkMode ? 'bg-slate-800' : 'bg-blue-50'}`}>
                            <div className={`w-8 h-8 rounded-full flex items-center justify-center ${isDarkMode ? 'bg-card' : 'bg-blue-100'}`}>
                                <BarChart3 className={`h-4 w-4 ${isDarkMode ? 'text-blue-400' : 'text-blue-600'}`} />
                            </div>
                            <div className="flex-1">
                                <p className={`text-sm font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Production entries added</p>
                                <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{recentEntries} entries in the last 24 hours</p>
                            </div>
                        </div>
                    )}

                    <div className={`flex items-center space-x-3 p-3 rounded-lg ${isDarkMode ? 'bg-slate-800' : 'bg-green-50'}`}>
                        <div className={`w-8 h-8 rounded-full flex items-center justify-center ${isDarkMode ? 'bg-card' : 'bg-green-100'}`}>
                            <Activity className={`h-4 w-4 ${isDarkMode ? 'text-green-400' : 'text-green-600'}`} />
                        </div>
                        <div className="flex-1">
                            <p className={`text-sm font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>System active</p>
                            <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>All monitoring systems operational</p>
                        </div>
                    </div>

                    <div className={`flex items-center space-x-3 p-3 rounded-lg ${isDarkMode ? 'bg-slate-800' : 'bg-purple-50'}`}>
                        <div className={`w-8 h-8 rounded-full flex items-center justify-center ${isDarkMode ? 'bg-card' : 'bg-purple-100'}`}>
                            <Users className={`h-4 w-4 ${isDarkMode ? 'text-purple-400' : 'text-purple-600'}`} />
                        </div>
                        <div className="flex-1">
                            <p className={`text-sm font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Field operations</p>
                            <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{activeWellsCount} active wells being monitored</p>
                        </div>
                    </div>
                </div>
            </div>
        </motion.div>
    );
}
